import { isEmpty } from 'lodash';

const checkIsResetAllFilter = ({ search, role, brand, platform }) => {
  return (
    !isEmpty(search) ||
    !isEmpty(role) ||
    !isEmpty(brand) ||
    !isEmpty(platform)
  );
};

export default checkIsResetAllFilter;
